import styled from 'styled-components';

export const RenderTabelProjectWrap = styled.div`
	margin-top: 58px;
	overflow: hidden;
	.tit {
		padding: 10px 7px;
		font-size: 16px;
		font-weight: 400;
		color: #344563;
	}
	.table-list {
		padding: 16px 14px;
		background: #ffffff;
		box-shadow: 0px 4px 12px 0px rgba(23, 43, 77, 0.08);
		border-radius: 4px;
		.table-opt {
			cursor: pointer;
			color: #0052cc;
			&:hover {
				text-decoration: underline;
			}
		}
		.ant-table-content {
			border: 1px dashed #dfe1e6;
		}
		.ant-table-thead .ant-table-cell {
			height: 50px;
			background: #fafbfc;
			border-bottom: none;
			font-size: 14px;
			font-weight: 400;
			color: #6c788c;
		}
	}
`;
